// src/AuthContext.js
import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isShareAuthenticated, setIsShareAuthenticated] = useState(false);
  const [isSharedTokenVerified, setSharedTokenVerified] = useState(false);


  return (
    <AuthContext.Provider value={{ isShareAuthenticated, setIsShareAuthenticated, isSharedTokenVerified, setSharedTokenVerified }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
